module.exports = __webpack_public_path__ + "img/is-completed-status-icon.671f42a9.svg";